module.exports = __webpack_public_path__ + "static/img/tel.89523b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tel.png
// module id = 248
// module chunks = 99